import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import * as g from 'src/app/globals';
import { DOCUMENT } from '@angular/common';
import { AppInitService } from './services/app-init.service';

@Injectable({
  providedIn: 'root',
})
export class CanActivateBasic implements CanActivate {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private authenticationService: AuthenticationService,
    private appInitService: AppInitService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const ltParam = route.queryParamMap.get('lt');
    console.log('lt param:', ltParam); // This will log: c992c4cd-a8fa-4a81-8a12-39f1ca2c9817
    if (ltParam != null) {
      this.authenticationService.afterLogin(
        ltParam,
        true,
        this.document,
        null,
        this.appInitService,
        true
      );
    } else {
      if (g.getToken() === null || g.getToken() === '') {
        const url = window.location.pathname;
        if (g.redirectToEmployeeLogin) {
          this.router.navigate([
            '/apps/authentication/login',
            { returnUrl: url },
          ]);
        } else if (g.redirectToExternalLogin) {
          this.router.navigate(['/apps/authentication/external-login']);
        } else {
          this.router.navigate([
            '/apps/authentication/landing',
            { returnUrl: url },
          ]);
        }

        return false;
      }

      if (window.location !== window.parent.location) {
        return true;
      }

      return this.authenticationService
        .isTokenValid()
        .then((r: { Success: boolean; Message: string; Area: number }) => {
          if (r.Success === false) {
            if (g.redirectToEmployeeLogin) {
              this.router.navigate(['/apps/authentication/login']);
            } else if (g.redirectToExternalLogin) {
              this.router.navigate(['/apps/authentication/external-login']);
            } else {
              this.router.navigate(['/apps/authentication/landing']);
            }
          } else if (r.Success && (r.Area === 2 || r.Area === 3)) {
            this.router.navigate(['/apps/external-portal/index']);
          }

          return r.Success && r.Area === 1;
        });
    }
  }
}
